import moment from "moment";
import { IMoney } from "./models";

export const formatMoney = (money: IMoney) => {
    return money.currency.isCrypto ?
        formatCrypto(money.amount) :
        formatUS(money.amount);
}

export const formatUS = (value?: number, minimumFractionDigits?: number): string => {
    if (value === undefined || isNaN(value)) {
        return '';
    }

    return value.toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
}

export const formatCrypto = (value?: number): string => {
    if (value === undefined || isNaN(value)) {
        return '-';
    }

    return value.toLocaleString('en-US', { maximumFractionDigits: 8, minimumFractionDigits: 2 });
}

export function formatPrice(price: number, format?: string): string {
    if (!format) {
        return price.toString();
    }

    const fractionDigits = parseInt(format.replace('F', ''), 10);
    if (!isNaN(fractionDigits) && Number.isSafeInteger(fractionDigits) && fractionDigits >= 0) {
        return price.toFixed(fractionDigits);
    } else {
        console.log('format could not be applied: ', format);
    }

    return price.toString();
}

export const formatDuration = (value?: number): string => {
    if (value === undefined || isNaN(value)) {
        return '';
    }

    const duration = moment.duration(value / 10000);
    return `${duration.days()} days ${duration.hours()} hours ${duration.minutes()} minutes ${duration.seconds()} seconds ${duration.milliseconds().toFixed(0)} ms`;
}

export const formatDateTime = (value?: Date): string => {
    if (value === undefined) {
        return '';
    }

    const dt = moment(value);

    if (dt.isValid()) {
        return dt.format('DD-MM-YYYY HH:mm');
    }

   return '';
}


export function formatTxType(txType: number, format?: string): string {
    switch (txType) {
        case 0:
            return '';
            break;
        case 1:
            return 'Trade';
            break;
        case 2:
            return 'Deposit';
            break;
        case 4:
            return 'Withdrawal';
            break;
        case 8:
            return 'Fee';
            break;
        case 16:
            return 'Payment';
            break;
        default:
            return '';
    }
}
